import {ChangeDetectorRef, Component, ElementRef, Renderer2} from '@angular/core';
import {DynamicFormService} from '../../../dynamic-form/dynamic-form.service';
import {BaseFieldComponent} from '../../base/base-field/base-field.component';
import {ButtonFieldConfig} from '../button-field.config';
import {EventDispatcherService} from '../../../events/event-dispatcher.service';

@Component({
    selector: 'mydocma-form-button-field',
    templateUrl: './button-field.component.html',
    styleUrls: ['./button-field.component.scss']
})
export class ButtonFieldComponent extends BaseFieldComponent<ButtonFieldConfig> {

    public readonly staticCssClass = 'mydocma-button-field';

    constructor(
        public readonly dynamicFormService: DynamicFormService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly eventDispatcher: EventDispatcherService,
        element: ElementRef,
        renderer: Renderer2
    ) {
        super(dynamicFormService, changeDetectorRef, eventDispatcher,element,renderer);
    }

    public onClick() {
        if ((this.fieldWrapper.config as ButtonFieldConfig).click) {
            (this.fieldWrapper.config as ButtonFieldConfig).click();
        }

        super.onControlClick();
    }
}
